import idbClass from '../api/idb';

function deleteProject() {
  new idbClass().deleteProject();
}

function saveProject(project: any) {
  new idbClass().saveProject(project);
}

async function getProject() {
  return await new idbClass().getProject();
}

export const idbService = {
  deleteProject,
  saveProject,
  getProject
};
